import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import CdkeyModalStore from './store';
import Link from '@src/components/link';
import { getLocales } from '@src/global-locales/get-page-locales-data';

const styles = require('./index.less');
/**
 * 弹窗模板, 可以快速套用修改
 * @param {CdkeysModalStore} store
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CdkeyModalModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  const ControlBtn = ({ children, className, ...props }) => {
    return (
      <Link {...props} className={cx(styles.controlBtn, className)}>
        <div className={styles.hoverGroup} style={{ backgroundImage: `url(${require('./images/comfirm-btn/comfitm-btn-bg.png')})` }}>
          <div data-name="左侧光影" className={styles.leftShodw}>
            <div data-name="bg1" className={styles.bg1} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-left-1.png')})` }} />
            <div data-name="bg2" className={styles.bg2} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-left-2.png')})` }} />
            <div data-name="bg3" className={styles.bg3} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-left-3.png')})` }} />
            <div data-name="bg4" className={styles.bg4} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-left-4.png')})` }} />
          </div>
          <div data-name="右侧光影" className={styles.rightShodw}>
            <div data-name="bg1" className={styles.bg1} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-right-1.png')})` }} />
            <div data-name="bg2" className={styles.bg2} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-right-2.png')})` }} />
            <div data-name="bg3" className={styles.bg3} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-right-3.png')})` }} />
            <div data-name="bg4" className={styles.bg4} style={{ backgroundImage: `url(${require('./images/comfirm-btn/hover-right-4.png')})` }} />
          </div>
        </div>
        {children}
      </Link>
    );
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.cdkeyModalModalRoot)}>
        <div className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.contentBox} />
        <div className={styles.controlBox}>
          <ControlBtn onClick={store.redeemCdKey}>{getLocales('gift.claim_rewards_btn_text')}</ControlBtn>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(CdkeyModalModal, CdkeyModalStore);
